<template>
  <BaseLayout page-default-back-link="/nativeTab/news" pageTitle="录入资料">
    <ion-content class="certification-inputData">
      <ProgressBar :data="progressBarData" />
      <div class="card f-1">
        <div class="f-center title m-b-20" @click="ss">录入个人资料</div>
        <div
          v-for="(item, index) in keysData"
          class="pc-input-box"
          :class="[
              {'pc-input-is-error' : requiredErrorKey === item.key},
              {'pc-input-is-required' : !form[item.key] && item.isRequired},
              {'hidden m-b-0' : item.isHide },
              {'m-b-50': keysData.length - 1 == index}
          ]"
          :key="index"
        >
          <input
            v-if="item.type == 'text'"
            class="is-required pc-input"
            :ref="el => nodes[item.key].value = el"
            v-model="form[item.key]"
            @blur="onBlur"
            :placeholder="item.label"
          />
          <input
            v-if="item.type == 'actionSheet'"
            class="is-required pc-input"
            :ref="el => nodes[item.key].value = el"
            :value="listToJson(selects[item.key])[form[item.key]]"
            @blur="onBlur"
            @click="presentActionSheet(item.key)"
            :placeholder="item.label"
          />
          <div class="w-100b h-100b" v-if="item.type == 'date'">
            <input
              class="pc-input"
              :ref="el => nodes[item.key].value = el"
              v-model="form[item.key]"
              @blur="onBlur"
              :placeholder="item.label"
            />
            <ion-datetime
              class="pc-input-date"
              @ionChange="(t) => onDateChange(item.key, t.detail.value)"
              display-format="YYYY MM DDDD"
              min="1950"
              max="2020"
              :value="form[item.key]"
              cancel-text="取消"
              done-text="确定"
              mode="ios"
            ></ion-datetime>
          </div>
        </div>
        <ion-button expand="block" @click="onSubmit">提交</ion-button>
      </div>
    </ion-content>
  </BaseLayout>
</template>

<script>
import router from '@/router'
import * as yup from 'yup'
import { ref, reactive, onBeforeMount } from 'vue'
import { ProgressBar, Dialog } from '@/view/certification/components'
import formData from '@/view/certification/formData'
import { useRoute } from 'vue-router'
import { dictApi, certificationApi } from '@/apis'
import { actionSheetController } from '@ionic/vue'
import { toast, loadingCreate } from '@/utils/alert'
import progressBarFulfillImage from '@/view/certification/assets/progressBar-fulfill.png'
import progressBarProcessingImage from '@/view/certification/assets/progressBar-processing.png'
import progressBarNotStartedImage from '@/view/certification/assets/progressBar-notStarted.png'
import { useStore } from 'vuex'
import dayjs from 'dayjs'
import webviewCall from '@/utils/webviewCall'

export default {
  setup() {
    const store = new useStore()
    const progressBarData = [
      {
        label: 'STEP 1',
        title: '注册账号',
        image: progressBarFulfillImage,
        btnText: '已完成',
        barClass: 'processing-bar',
        status: 'fulfill',
      },
      {
        label: 'STEP 2',
        title: '录入资料',
        image: progressBarProcessingImage,
        btnText: '进行中',
        barClass: 'notStarted-bar',
        status: 'processing',
      },
      {
        label: 'STEP 3',
        title: '完成录入',
        image: progressBarNotStartedImage,
        status: 'notStarted',
      },
    ]
    const textDatas = {
      individual: {
        title: '个人录入',
      },
      enterprise: {
        title: '企业录入',
      },
    }

    const route = new useRoute()

    const userType = route.query.userType || 'individual'
    document.getElementsByTagName('title')[0].innerText =
      textDatas[userType].title
    const keysData = formData[userType]
    const mData = keysData.reduce((o, item) => {
      return { ...o, [item.key]: item.value || '' }
    }, {})

    const nodes = keysData.reduce((o, item) => {
      return { ...o, [item.key]: ref(null) }
    }, {})

    const form = reactive(mData)

    const selects = reactive({
      userSex: [],
      nation: [],
    })

    const requiredErrorKey = ref('')

    const onBlur = () => {
      requiredErrorKey.value = ''
    }

    const presentActionSheet = async (key) => {
      const sheetSelect = selects[key].map((item) => {
        return {
          text: item.dictName,
          role: item.dictCode,
        }
      })
      const actionSheet = await actionSheetController.create({
        // header: 'Albums',
        cssClass: 'my-custom-class',
        buttons: [
          ...sheetSelect,
          {
            text: '取消',
            role: 'cancel',
          },
        ],
      })
      await actionSheet.present()

      const { role } = await actionSheet.onDidDismiss()
      if (['cancel', 'backdrop'].includes(role)) {
        return
      }
      form[key] = role
    }

    const onDateChange = (key, value) => {
      form[key] = dayjs(value).format('YYYY/MM/DD')

      console.log('onDateChange', key, form[key])
    }

    const onSubmit = async () => {
      const requiredKeys = keysData
        .filter(({ isRequired }) => isRequired)
        .map(({ key }) => key)
      const errKey = requiredKeys.find((key) => form[key] == '')
      console.log('onSubmit', errKey)
      if (errKey) {
        const key = errKey
        const node = nodes[`${key}`]
        console.log('node', nodes, errKey, key)
        node.value.focus()
        requiredErrorKey.value = key
        return
      }

      const ajaxs = {
        individual: certificationApi.individualInputData,
        enterprise: certificationApi.enterpriseInputData,
      }
      const loading = await loadingCreate('资料提交中...')
      try {
        const data = await ajaxs[userType](form)
        console.log(route.query.isWebview, userType, data.id)
        if (route.query.isWebview) {
          console.log(11111)
          webviewCall.callWebview('navigatorPushNamed', '/main')
        } else {
          console.log(22222)

          router.replace({
            path: '/certification/inputDataFulfill',
            query: { userType, id: data.id },
          })
          store.dispatch('user/getInfo')
        }
      } catch (error) {
        console.log('___error___', error)
      } finally {
        loading.dismiss()
      }
    }
    const ss = () => {
      console.log('222')
      // webviewCall.callWebview('navigatorToMain', 'main')
    }
    onBeforeMount(async () => {
      const dictData = await dictApi.base({
        dictTag: '性别|民族',
      })
      selects.userSex = dictData['性别']
      selects.nation = dictData['民族']
    })
    return {
      ss,
      progressBarData,
      form,
      selects,
      onBlur,
      onSubmit,
      onDateChange,
      nodes,
      requiredErrorKey,
      userType,
      mData,
      keysData,
      presentActionSheet,
    }
  },
  components: { ProgressBar, Dialog },
}
</script>

<style lang="scss">
@import 'style.scss';

.certification-inputData {
  .card {
    padding: 40px 75px 75px;
  }
  .title {
    font-size: 34px;
    font-family: PingFang SC;
    color: #1f2329;
  }
  .logo {
    width: 64px;
    height: 63px;
  }
}
</style>